import React from "react";
import "./App.css";
import Base from "./base/base";
import Toast from "./components/Toast";

function App() {
  return (
    <>
      <Toast />
      <Base />
    </>
  );
}

export default App;
